<template lang="html">
    <div id="verifyKbaWrap">
        <p>Please answer the questions below so that we can verify your identity and continue to process your application. All questions must be answered</p>

        <form v-if="!submitSuccess" id="verifyQuestionsForm" class="form" @submit.prevent="submitAnswers">

            <div v-if="submitError" class="mb-3">
                <div class="alert alert-danger">
                    {{ submitErrorMessage }}
                </div>
            </div>

            <question v-for="question in questions" :key="question.id" :question="question" @answerselected="answerSelected"></question>
            <button class="btn btn-theme btn-sm" :disabled="!allAnswersSelected"><i class="fas fa-arrow-right mr-2"></i>Submit Answers</button>
        </form>
        <div v-else>
            <div class="alert alert-success">
                Your identity has been succesfully verified. Please stand by while you get redirected.
            </div>
        </div>
    </div>
</template>

<script>

import Question from '.././verify/Question';

export default {
    props: ['questions', 'trackkey'],
    components: {
        'question' : Question,
    },
    data() {
        return {
            answers : {},
            answersCount : 0,
            submitSuccess : false,
            submitError : false,
            submitErrorMessage : ""
        }
    },
    computed: {
        allAnswersSelected() {
            return this.answersCount == this.questions.length;
        }
    },
    watch: {

    },
    methods: {
        answerSelected(data) {
            this.answers[data.questionId] = data.answerId;
            this.answersCount = Object.keys(this.answers).length;
        },
        submitAnswers() {
            const that = this;

            this.$emit('loading', { loading : true });

            const url = '/verify-kba/' + this.trackkey;

            axios
                .post(url, { answers : that.answers })
                .then(
                    response => {

                        switch (parseInt(response.data.response_code)) {
                            case 1:
                                that.submitError = false;
                                that.submitErrorMessage = "";
                                that.submitSuccessMessage = typeof response.data.response_text != 'undefined' ? response.data.response_text : "Your identity has been verified succesfully.";
                                that.submitSuccess = true;
                                setTimeout(function () {
                                    window.location.replace(that.$parent.baseUrl + "/apply");
                                    // window.location = that.$parent.baseUrl + "/apply";
                                }, 3000);
                                break;
                            default:
                                that.submitSuccess = false;
                                that.submitSuccessMessage = "";
                                that.submitError = true;
                                that.submitErrorMessage = typeof response.data.response_text != 'undefined' ? response.data.response_text : "We were unable to verify your identity";

                                setTimeout(function () {
                                    window.location.replace(that.$parent.baseUrl + "/apply");
                                    // window.location = that.$parent.baseUrl + "/apply";
                                }, 3000);
                        }

                        this.$emit('loading', { loading : false });

                        VueScrollTo.scrollTo('#verifyKbaWrap', 500)
                    }
                );

        },
    },
    mounted() {
        const that = this;
    }
}
</script>

<style lang="css" scoped>
    .btn-theme {
        /* color: #3f7eeb; */
    }
</style>
